const triggerInputAfterReturn = (e) => {
  if (e.key !== 'Enter') return;
  const { srcElement } = e;

  const inputEvent = new KeyboardEvent('input', {
    bubbles: true,
    cancelable: true,
  });

  srcElement.dispatchEvent(inputEvent);
};

export default triggerInputAfterReturn;
